import { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle, Save } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const errText = (e) => { const d = e.response?.data?.detail; return typeof d === "string" ? d : Array.isArray(d) ? "Şifreler en az 6 karakter olmalı" : "İşlem başarısız"; };
const EMPTY = { current_password: "", pw1: "", pw2: "" };

export function GateForm() {
  const [info, setInfo] = useState(null), [f, setF] = useState(EMPTY), [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API}/settings/gate`).then((r) => setInfo(r.data)).catch(() => {}); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    if (f.pw1 === f.pw2) return toast.error("İki güvenlik şifresi birbirinden farklı olmalı");
    setBusy(true);
    try { const r = await axios.put(`${API}/settings/gate`, f); setInfo(r.data); setF(EMPTY); toast.success("Güvenlik şifreleri güncellendi. Bir sonraki girişte yeni şifreler sorulur."); }
    catch (err) { toast.error(errText(err)); }
    setBusy(false);
  };
  const input = (k, label, ac) => <label className="settings-field">{label}<input type="password" autoComplete={ac} required minLength={k === "current_password" ? 1 : 6} value={f[k]} onChange={set(k)} data-testid={`gate-settings-${k}`} /></label>;
  return (
    <form onSubmit={save} data-testid="gate-settings-form">
      {info?.temporary && <p className="gate-note warn" data-testid="gate-settings-temporary"><AlertTriangle size={15} />Şu an geçici güvenlik şifreleri kullanılıyor. Lütfen kendi şifrelerinizi belirleyin.</p>}
      {input("current_password", "Panel giriş şifreniz (onay için)", "current-password")}
      {input("pw1", "Yeni 1. güvenlik şifresi", "new-password")}
      {input("pw2", "Yeni 2. güvenlik şifresi", "new-password")}
      <small className="form-hint">En az 6 karakter. İki şifre farklı olmalı. Unutursanız giriş ekranındaki "Güvenlik şifrelerimi unuttum" ile e-postanıza yenileme bağlantısı gönderilir.</small>
      <button className="primary-btn" disabled={busy} data-testid="gate-settings-save"><Save size={15} />{busy ? "Kaydediliyor…" : "Kaydet"}</button>
    </form>
  );
}
